import moment from 'moment';
import { DictionaryType } from '../api/dictionaryType.enum';
import { BaseObjectRequiresDictionaries, Dictionary, DictionaryItem } from '../public_api';
import { SourcesDictionaryItem } from './dictionaries/sourcesDictionaryItem';

export class ObservationSummary extends BaseObjectRequiresDictionaries {
  public static readonly KEYS = {
    ID: 'observation_id',
    OBS_TYPE_CODE: 'observation_type_code',
    DESCRIPTION: 'description',
    COUNTRY_CODE: 'country_code',
    SOURCE_CODE: 'source_code',
    DATE_OBSERVED: 'date_observed',
    LOCATION: 'location',
  };

  public static readonly requiredDictionaryTypes = [
    DictionaryType.OBSERVATION_TYPES,
    DictionaryType.COUNTRIES_USED,
    DictionaryType.SOURCES,
  ];

  public readonly id: string;
  public readonly type: DictionaryItem;
  public readonly description: string;
  public readonly country: DictionaryItem;
  public readonly source: SourcesDictionaryItem;
  public readonly dateObserved: moment.Moment;
  public readonly location: GeoJSON.Feature;
  public readonly locationPoint: LocationPoint;

  protected constructor(sourceObject: Record<string, unknown>, dictionaries?: Array<Dictionary>) {
    super(sourceObject, dictionaries);

    this.id = this._getString(ObservationSummary.KEYS.ID);

    this.type = this._getDictionary(DictionaryType.OBSERVATION_TYPES).getItem(
      this._getString(ObservationSummary.KEYS.OBS_TYPE_CODE),
    );

    this.description = this._getString(ObservationSummary.KEYS.DESCRIPTION);

    this.country = this._getDictionary(DictionaryType.COUNTRIES_USED).getItem(
      this._getString(ObservationSummary.KEYS.COUNTRY_CODE),
    );

    this.source = this._getDictionary(DictionaryType.SOURCES).getItem(
      this._getString(ObservationSummary.KEYS.SOURCE_CODE),
    ) as SourcesDictionaryItem;

    this.dateObserved = moment(this._getString(ObservationSummary.KEYS.DATE_OBSERVED));

    this.location = this._getValue(ObservationSummary.KEYS.LOCATION) as GeoJSON.Feature;

    this.locationPoint =
      null != this.location && this.location.geometry.type === 'Point'
        ? ({
            lat: this.location.geometry.coordinates[1],
            lon: this.location.geometry.coordinates[0],
          } as LocationPoint)
        : null;
  }
}

export interface LocationPoint {
  lat: number;
  lon: number;
}
